<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";

// END CONFIGURE axios
export default {
  page: {
    title: "Patient Registration",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader,ModelListSelect },
  data() {
    return {
      test: "",
      previous_balance: 0,
      Balance_warning: "",
      current_data: moment(new Date()).format("YYYY-MM-DD"),
      submitted: false,
      submitform: false,
      submit: false,
      typesubmit: false,
      // PATIENT DATA INPUTS
      data: {
        patient_name:"",
        patient_id: "",
        visit_id: "",
        department: "",
        patient_gender: "",
        patient_muac: "",
        insurance_status: "0",
        pressure: "",
        patient_pulse: "",
        patient_service: "",
        service_cost: "",
        service_qty: "1",
        patient_temperature: "",
        patient_weight: "",
        patient_height: "",
        insurance_company: "",
        package: "",
      },
      validation_errors: {
        errortrack: false,
        patient_visitdate: "",
        department: "",
        patient_gender: "",
        patient_muac: "",
        insurance_status: "",
        pressure: "",
        patient_pulse: "",
        patient_service: "",
        service_cost: "",
        service_qty: "",
        patient_temperature: "",
        patient_weight: "",
        patient_height: "",
        insurance_company: "",
        package: "",
      },
      // PAGE REQUIRED DATA
      allCountryData: [],
      // PAGE HEADERS
      title: "TRIAGE",
      items: [
        {
          text: "Client Section",
          href: "/",
        },
        {
          text: "Triage",
          active: true,
        },
      ],
      //Speech
      voicevalidation: 0,
      statement: "",
      selectedVoice: 2,
      synth: window.speechSynthesis,
      voiceList: [],
      greetingSpeech: new window.SpeechSynthesisUtterance(),
      // END SPEECH
    };
  },
  methods: {
    ...mapActions({
      SaveTriage: "patients/saveTriage",
      FetchTriagePatients: "patients/fetchTriagePatients",
      FetchLabServices: "services/fetchLabServices",
      FetchConsultationServices: "services/fetchConsultationServices",
      FetchRadiologyServices: "services/fetchRadiologyServices",
      FetchProcedureServices: "services/fetchProcedureServices",
      FetchDentalServices: "services/fetchDentalServices",
      FetchAntentalServices: "services/fetchAntenatalServices",
      FetchInsuranceServices: "insurance/fetchInsuranceServices",
      FetchInsuranceCompanies: "insurance/fetchInsuranceCompanies",
      FetchInsurancePackages: "insurance/fetchInsuranceCompaniesPackages",
    }),
    setTriageP(){
       this.data.patient_name = this.max_registered;
    },
    // COMMA SEPERTOR FUNCTION
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    // END COMMA SEPERATOR
    FilterTriagePatient() {
      let ret_data = this.TriagePatients.filter((element) => {
        return element.id == this.data.patient_name;
      });
      this.test = ret_data[0];
  this.data.patient_id = ret_data[0].patient_id,
  this.data.visit_id = this.data.patient_name;
      if(ret_data[0].package_id){
  this.data.insurance_company = ret_data[0].company_id,
  this.data.package = ret_data[0].package_id,
  this.data.insurance_status = 1

      }else{
  this.data.insurance_company = "",
  this.data.package = "",
  this.data.insurance_status = 0
      }
    
    },

    // END SET COUNTRY CODE
    // SAVE PATIENT
    Save_Triage() {
      this.validation_errors.errortrack = false;

      if (this.data.patient_temperature == "") {
        this.validation_errors.patient_temperature = "";
      } else if (isNaN(this.data.patient_temperature)) {
        this.validation_errors.patient_temperature =
          "Temperature should not contain letters";
        this.validation_errors.errortrack = true;
      } else if (
        this.data.patient_temperature < 25 ||
        this.data.patient_temperature > 45
      ) {
        this.validation_errors.patient_temperature =
          "Please Enter a valid temperature ";
        this.validation_errors.errortrack = true;
      } else {
        this.validation_errors.patient_temperature = "";
      }

      

      // END FINAL VALAIDATIONS
      if (
        this.submitted == false &&
        this.validation_errors.errortrack == false
      ) {
        this.SaveTriage(this.data);
        this.submitted = true;
        return;
      }
      if (this.validation_errors.errortrack == true) {
        this.statement =
          "Your inputs are invalid, please revise and correct them.";
        this.VoceTalkOut();
      }
    },
    // AND SAVE PATIENT
   
    // END SET SERVICE PRICE

    /**
     * STAR VOICE VALIDATION
     */

  
    listenForSpeechEvents() {
      this.greetingSpeech.onstart = () => {};
      this.greetingSpeech.onend = () => {};
    },

    VoceTalkOut() {
      if (this.voicevalidation) {
        this.greetingSpeech.text = this.statement;
        this.greetingSpeech.voice = this.voiceList[this.selectedVoice];
        this.synth.speak(this.greetingSpeech);
      }
    },

    // END VOICE VALIDATION
    chagewarnSatatus() {
      let set = { status: this.voicevalidation };
      localStorage.setItem("form_validation", JSON.stringify(set));
    },
    setWarnStatus() {
      if (localStorage.getItem("form_validation")) {
        let k = JSON.parse(localStorage.getItem("form_validation"));
        this.voicevalidation = k.status;
      } else {
        let set = { status: this.voicevalidation };
        localStorage.setItem("form_validation", JSON.stringify(set));
      }
    },
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),

    // MAP GETTERS
    ...mapGetters("patients", ["saving_status", "TriagePatients","max_registered"]),
    ...mapGetters("services", [
      "departments",
      "labServices",
      "consultationServices",
      "radiologyServices",
      "procedureServices",
      "dentalServices",
      "antenatalServices",
    ]),

    // FILTER SERVIVES DEPENDING ON A SELECTED DEPARTMENT
    filterSevices: function () {
      if (this.data.department == 1) {
        return this.consultationServices;
      } else if (this.data.department == 2) {
        return this.radiologyServices;
      } else if (this.data.department == 3) {
        return this.procedureServices;
      } else if (this.data.department == 4) {
        return this.labServices;
      } else if (this.data.department == 6) {
        return this.dentalServices;
      } else if (this.data.department == 7) {
        return this.antenatalServices;
      } else {
        return [];
      }
    },
    // END FILTER SERVICES DEPENDING ON A SELECTED DEPARTMENT

    //FILTER INSURANCE PACKAGES
    filteredComapnyPackages: function () {
      if (this.InsuranceCompaniesPackages) {
        return this.InsuranceCompaniesPackages.filter((pks) => {
          return pks.company_id == this.data.insurance_company;
        });
      } else {
        return [];
      }
    },
    // END FILTER INSURANCE SERVICES

    //FILTER INSURANCE PACKAGES
    filteredPackagesServices: function () {
      if (this.InsuranceServices) {
        return this.InsuranceServices.filter((pks) => {
          return (
            pks.package_id == this.data.package &&
            pks.serviceType == this.data.department
          );
        });
      } else {
        return [];
      }
    },
    // END FILTER INSURANCE SERVICES
  },
  watch: {
    max_registered(newVal){
      if(newVal){
      this.setTriageP()
      }
    },
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          (this.data = {
            ret_status: 0,
            patient_visitdate: moment(new Date()).format("YYYY-MM-DD"),
            department: "",
            patient_gender: "",
            patient_muac: "",
            insurance_status: "0",
            pressure: "",
            patient_pulse: "",
            patient_service: "",
            service_cost: "",
            service_qty: "1",
            patient_temperature: "",
            patient_weight: "",
            patient_height: "",
            insurance_company: "",
            package: "",
          }),
            (this.submitted = false);
          this.$toast.success(this.notification_message.msg);
        } else {
          this.submitted = false;
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
   
  },
  mounted() {
    // wait for voices to load
    // I can't get FF to work without calling this first
    // Chrome works on the onvoiceschanged function
    this.voiceList = this.synth.getVoices();

    if (this.voiceList.length) {
      this.isLoading = false;
    }

    this.synth.onvoiceschanged = () => {
      this.voiceList = this.synth.getVoices();
      // give a bit of delay to show loading screen
      // just for the sake of it, I suppose. Not the best reason
      setTimeout(() => {
        this.isLoading = false;
      }, 800);
    };

    this.listenForSpeechEvents();
  },
  created() {
    // Call Actions
    this.setWarnStatus();
    this.FetchTriagePatients();
    this.FetchLabServices();
    this.FetchConsultationServices();
    this.FetchRadiologyServices();
    this.setTriageP();

    // END Call Actions
    setTimeout(() => {
      this.FetchProcedureServices();
      this.FetchDentalServices();
      this.FetchAntentalServices();
    }, 2000);
  },
};
</script>
<style scoped></style>
<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
          
             <div class="row">
                <div
                  class="col-md-4 form-check form-switch form-switch-md mb-3"
                >
                  <input
                    @change="chagewarnSatatus()"
                    v-model="voicevalidation"
                    v-if="voicevalidation"
                    class="form-check-input"
                    type="checkbox"
                    id="SwitchCheckSizemd"
                    checked
                  />
                  <input
                    v-else
                    v-model="voicevalidation"
                    @change="chagewarnSatatus()"
                    class="form-check-input"
                    type="checkbox"
                    id="SwitchCheckSizemd"
                  />
                  <label
                    class="form-check-label text-primary"
                    for="SwitchCheckSizemd"
                    >Voice validation</label
                  >
                </div>
                <div class="col-md-8" v-if="previous_balance > 0">
                  <h5 style="color: orange">
                    This patient has a pending balance of
                    <b>{{ thousandSeprator(previous_balance) }}</b>
                  </h5>
                </div>
              </div>
             <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="col-form-label" for="userName"
                        >Patient name <span class="text-danger">*</span></label
                      >
                      <model-list-select
                        @input="FilterTriagePatient"
                        :list="TriagePatients ? TriagePatients : []"
                        v-model="data.patient_name"
                        option-value="id"
                        option-text="patient_name"
                        placeholder="select Patient"
                      >
                      </model-list-select>
                
                    </div>
                    <div class="form-group">
                      <label class="col-form-label" for="userName"
                        >Temperature ( &#x2103; )</label
                      >
                      <input
                        :class="{
                          'is-invalid': validation_errors.patient_temperature
                            ? true
                            : false,
                        }"
                        autocomplete="off"
                        v-model="data.patient_temperature"
                        id="userName"
                        type="text"
                        class="form-control"
                        name="temperature"
                        placeholder="Enter temperature (optional)"
                      />
                      <div
                        v-if="validation_errors.patient_temperature"
                        class="invalid-feedback"
                      >
                        <span
                          >{{ validation_errors.patient_temperature }}.</span
                        >
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-md-6">
                        <label class="col-form-label" for="password"
                          >Weight (kg)</label
                        >
                        <input
                          autocomplete="off"
                          v-model="data.patient_weight"
                          id="weight"
                          type="number"
                          min="0"
                          step="any"
                          name="weight"
                          class="form-control"
                          placeholder="Enter Weight (optional)"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label class="col-form-label" for="password"
                          >Height (cm)</label
                        >
                        <input
                          autocomplete="off"
                          v-model="data.patient_height"
                          id="height"
                          type="number"
                          min="0"
                          step="any"
                          name="height"
                          class="form-control"
                          placeholder="Enter Height in centimeters(cm) (optional)"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-6">
                        <label class="col-form-label" for="confirmpass"
                          >MUAC (cm)</label
                        >
                        <input
                          autocomplete="off"
                          v-model="data.patient_muac"
                          id="muac"
                          type="text"
                          name="muac"
                          class="form-control"
                          placeholder="Enter MUAC (optional)"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label class="col-form-label" for="confirmpass"
                          >Blood Pressure(mmHg)</label
                        >
                        <input
                          autocomplete="off"
                          v-model="data.pressure"
                          id="bloodpressure"
                          type="text"
                          name="bloodpressure"
                          class="form-control"
                          placeholder="Enter Blood Pressure (optional)"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="col-form-label" for="userName"
                        >Pulse (b/min)</label
                      >
                      <input
                        autocomplete="off"
                        v-model="data.patient_pulse"
                        id="Pulse"
                        type="text"
                        class="form-control"
                        name="Pulse"
                        placeholder="Enter Pulse (optional)"
                      />
                    </div>
                     <div class="form-group">
                          <label class="col-form-label" for="age">Email</label>
                          <input
                            :class="{
                              'is-invalid': validation_errors.patient_email
                                ? true
                                : false,
                            }"
                            autocomplete="off"
                            id="email"
                            type="text"
                            v-model="data.patient_email"
                            name="email"
                            class="form-control"
                            placeholder="Enter client email (optional)"
                          />
                          <div
                            v-if="validation_errors.patient_email"
                            class="invalid-feedback"
                          >
                            <span>{{ validation_errors.patient_email }}.</span>
                          </div>
                        </div>

   <div class="row">
                      <div class="form-group col-md-6" v-if="data.patient_next_ofkin">
                        <label class="col-form-label" for="nextofkin">Next of Kin</label>
                        <input
                          id="nextofkin"
                          type="text"
                          v-model="data.patient_next_ofkin"
                          name="nextofkin"
                          class="form-control"
                          placeholder="Enter next of kin (optional)"
                        />
                      </div>
                      <div class="form-group" v-else>
                        <label class="col-form-label" for="nextofkin">Next of Kin</label>
                        <input
                          id="nextofkin"
                          type="text"
                          v-model="data.patient_next_ofkin"
                          name="nextofkin"
                          class="form-control"
                          placeholder="Enter next of kin (optional)"
                        />
                      </div>
                      <div class="form-group col-md-6" v-show="data.patient_next_ofkin">
                        <label class="col-form-label" for="nextofkin">
                          Next of Kin Contact
                          <span class="text-danger">*</span></label
                        >
                        <div class="input-group">
                          <button
                            class="btn btn-outline-secondary"
                            type="button"
                            id="inputGroupFileAddon03"
                          >
                            +{{ data.country_code }}
                          </button>
                          <input
                            @keyup="nextofkinContactValid()"
                            :class="{
                              'is-invalid': validation_errors.contact_next_ofkin
                                ? true
                                : false,
                            }"
                            id="nextofkin"
                            type="text"
                            v-model="data.contact_next_ofkin"
                            name="contact"
                            autocomplete="off"
                            class="form-control"
                            placeholder="Enter contact"
                          />
                          <div
                            v-if="validation_errors.contact_next_ofkin"
                            class="invalid-feedback"
                          >
                            <span>{{ validation_errors.contact_next_ofkin }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                        <label class="col-form-label">Facility</label>
                        <input
                          v-model="data.patient_facility"
                          class="form-control"
                          list="facil"
                          placeholder="Enter Facility"
                          autocomplete="off"
                        />
                        <datalist id="facil">
                          <option
                            v-for="(faci, v) in Facilities"
                            :data-value="faci.id"
                            :key="v"
                          >
                            {{ faci.facilityName }}
                          </option>
                        </datalist>
                      </div>
                   
                  </div>
                  <!-- end col -->
                </div>
                      <button
                        style="float:right;"
                        class="btn btn-success m-2"
                        type="button"
                        @click="Save_Triage()"
                      >
                        SUBMIT PATIENT
                        <b-spinner
                          v-if="saving_status"
                          variant="light"
                          small
                          role="status"
                        ></b-spinner>
                        <i v-else class="fa fa-check"></i>
                      </button>
            
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
